import './pdfjsWorker'
import { getDocument } from 'pdfjs-dist'

/**
 * Extract plain text from a PDF in the browser (hosted sign-in uploads).
 * Mirrors `owlbert-electron/src/renderer/lib/readFileForUserDocument.ts`.
 */
export async function extractPdfTextFromArrayBuffer(arrayBuffer: ArrayBuffer): Promise<string> {
  const loadingTask = getDocument({ data: arrayBuffer })
  const pdf = await loadingTask.promise
  const numPages = pdf.numPages
  const parts: string[] = []
  for (let i = 1; i <= numPages; i++) {
    const page = await pdf.getPage(i)
    const content = await page.getTextContent()
    const text = content.items
      .map((item) => ('str' in item ? (item as { str: string }).str : ''))
      .join(' ')
    parts.push(text)
  }
  await pdf.destroy().catch(() => {})
  return parts.join('\n\n').trim() || '(No extractable text)'
}
